import Router from 'App/routes/Router';
import ThemeProvider from 'gridosComponents/ThemeProvider';
import MessageBox from 'sharedComponents/MessageBox';
import moment from 'moment';
import { Suspense } from 'react';
import { IntlProvider } from 'react-intl';
import { useConfiguration } from 'store/hooks/useConfiguration';
import useLocaleMessages from '../../../locales/locales';
import AppFallback from '../../components/Fallback/AppFallback';

import 'moment/locale/nb';

const App = ({ locale }) => {
  const { theme } = useConfiguration();
  const isDarkMode = theme === 'dark';
  const [localeMessages, error] = useLocaleMessages(locale);

  if (!localeMessages && error) {
    return <MessageBox message="Something went wrong. Try again later or contact us for help." />;
  }
  if (!localeMessages) {
    return null;
  }

  moment.updateLocale('en', {
    week: {
      dow: 1,
    },
  });

  return (
    <ThemeProvider isDarkMode={isDarkMode}>
      <IntlProvider locale={locale} key={locale} messages={localeMessages}>
        <Suspense fallback={<AppFallback />}>
          <Router />
        </Suspense>
      </IntlProvider>
    </ThemeProvider>
  );
};

export default App;
